import { motion } from "framer-motion";
import { Reveal, StaggerGroup, staggerItem } from "@/components/Reveal";
import { MANIFESTO } from "@/data/site";

export default function Manifesto() {
  return (
    <section id="future-vision" className="bg-black py-24 sm:py-32">
      <div className="mx-auto max-w-6xl px-5 sm:px-8">
        <div className="max-w-3xl">
          <Reveal>
            <p className="font-display text-xs font-semibold uppercase tracking-[0.3em] text-brand">
              Future Vision
            </p>
          </Reveal>
          <Reveal delay={0.06}>
            <h2 className="mt-4 font-display text-3xl font-black leading-[1.05] tracking-tight text-white sm:text-4xl lg:text-5xl">
              We'll keep publishing tutorials, reviews, guides and technology
              resources.
            </h2>
          </Reveal>
        </div>

        <StaggerGroup className="mt-16 grid gap-px overflow-hidden rounded-2xl border border-white/10 bg-white/[0.08] md:grid-cols-3">
          {MANIFESTO.map((m) => (
            <motion.div
              key={m.no}
              variants={staggerItem}
              className="group bg-neutral-950 p-9 transition-colors duration-300 hover:bg-white/[0.04]"
            >
              <span className="font-display text-6xl font-black leading-none tracking-tight text-transparent [-webkit-text-stroke:1.5px_#4a4326] transition-[color] duration-300 group-hover:[-webkit-text-stroke:1.5px_#D4AF37]">
                {m.no}
              </span>
              <h3 className="mt-6 font-display text-xl font-bold tracking-tight text-white">
                {m.title}
              </h3>
              <p className="mt-3 text-sm leading-relaxed text-neutral-400">
                {m.body}
              </p>
            </motion.div>
          ))}
        </StaggerGroup>
      </div>
    </section>
  );
}
